import { Component, OnInit, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { OrderStatusConstants } from 'src/app/core/constants/order-status-constants';
import { OrderFacade } from 'src/app/store/order/facade';
import { OrderModel } from 'src/app/store/order/model';

@Component({
  selector: 'app-order-total',
  templateUrl: './order-total.component.html',
  styleUrls: ['./order-total.component.scss'],
  standalone: false,
})
export class OrderTotalComponent implements OnInit {
  private router = inject(Router);
  private orderFacade = inject(OrderFacade);

  @Input() order: OrderModel;
  @Input() sourceOrder: OrderModel;

  ngOnInit(): void {}

  isChanged(): boolean {
    return JSON.stringify(this.sourceOrder) !== JSON.stringify(this.order);
  }

  close() {
    this.router.navigate(['/orders']);
  }
}
